const PUBNUB_PUBLISH_KEY = 'pub-c-88325f51-4d4c-4198-a0f3-969bc85d3180';
const PUBNUB_SUBSCRIBE_KEY = 'sub-c-0e95917a-9c36-11ea-8d30-d29256d12d3d';

export { PUBNUB_PUBLISH_KEY, PUBNUB_SUBSCRIBE_KEY };
